<template>
    <div class="login-main">
        <el-row class="login-top">
            <el-col :span="24">
                <img :src='require("../../assets/image/" + getLogo("login_top.png"))' height="160px"/>
                <!-- <img src="../../assets/image/login_top.png"/> -->
                <p class="login-welcome">{{getWelcome('login.welcome')}}</p>
            </el-col>
        </el-row>
        <el-row class="login-contents">
            <el-col :span="24" class="login-form-box">
                <img class="login-left-top-tag" src="../../assets/image/login_left_top_tag.jpg" height="70" width="70"/>

                <div class="login-box">

                    <!--                    <div class="login-message-box">-->
                    <!--                        <p class="login-title">VIA Fleet云平台</p>-->
                    <!--                        <p class="login-info">基于大数据分析技术的企业级车辆管理平台，可以帮助企业定位车辆，分析驾驶行为，节省运营成本，降低运输风险。</p>-->
                    <!--                        <p class="login-info">迅速定位车辆，了解路况，掌握车辆最新动态。</p>-->
                    <!--                        <p class="login-info">紧贴行业特性，集成了大量的业务报表分析，最大程度上帮助企业控制风险，提高效率。</p>-->
                    <!--                        <div class="login-box-right">-->
                    <!--                            <p class="login-img"><img src="../../public/static/images/android.png" height="159"-->
                    <!--                                                   width="159"/>-->
                    <!--                            </p>-->
                    <!--                            <p><img src="../../public/static/images/google_play_icon.png" height="50" width="160"/></p>-->
                    <!--                        </div>-->
                    <!--                        <div class="login-box-right">-->
                    <!--                            <p><img src="../../public/static/images/ios.png" height="159" width="159"/></p>-->
                    <!--                            <p><img src="../../public/static/images/app_store_icon.png" height="50" width="160"/></p>-->
                    <!--                        </div>-->
                    <!--                    </div>-->


                    <div class="login-box-left">
                        <p class="login-img" v-if="isShowAndroid()">
                            <img :src='require("../../assets/image/" + getQrcodeAndroid("android.png"))'
                                 height="160"
                                 width="160"/>
                        </p>
                        <p v-if="isShowAndroid()">
                            <img :src="getGooglePlayIcon()" height="50" width="160"/>
                        </p>
                    </div>

                    <div class="login-form">
                        <img src="../../assets/image/login_position.png" height="196" width="392"/>
                        <el-form :model="user" ref="user" :rules="rules">
                            <el-form-item prop="name">
                                <el-input v-model.trim="user.name"
                                          :placeholder="$t('login.emailOrUserID')"
                                          @input.native="nameInputNoSpace"
                                          @keyup.enter.native="submitForm('user')">
                                    <template slot="prepend"><i class="el-icon-user-solid"></i></template>
                                </el-input>
                            </el-form-item>
                            <el-form-item prop="password">
                                <el-input v-model.trim="user.password"
                                          :placeholder="$t('login.password')"
                                          type="password"
                                          @input.native="passwordInputNoSpace"
                                          @keyup.enter.native="submitForm('user')">
                                    <template slot="prepend"><i class="el-icon-key"></i></template>
                                </el-input>
                            </el-form-item>
                            <!--<div class="tips">-->
                            <!--<span class="left"><el-checkbox v-model="user.remember">Remember me</el-checkbox></span>-->
                            <!--</div>-->
                            <div class="btn">
                                <el-button type="primary" class="sign" :loading="loadingStatus"
                                           @click="submitForm('user')">{{this.$t('login.signIn')}}
                                </el-button>
                            </div>
                            <!--<div class="login-forget-pwd">
                                <span class="right" @click="forgetPassword">{{$t('login.forgotPassword')}}</span>
                            </div>-->
                        </el-form>
                    </div>
                    <div class="login-box-right">
                        <p v-if="isShowIOS()">
                            <img :src='require("../../assets/image/" + getQrcodeIOS("ios.png"))'
                                 height="160"
                                 width="160"/>
                        </p>
                        <p v-if="isShowIOS()">
                            <img :src="getAppStoreIcon()" height="50" width="160"/>
                        </p>
                    </div>
                </div>
                <div class="login-footer-box">
                    <div>
                        <div class="footer-block-class"></div>
                        <div style="text-align: center" class="footer-block-class">
                            {{getCopyright('login.copyright')}}{{$t('login.allRightsReserved')}}
                        </div>
                        <div v-if="isPrivacyPolicyShow()" style="text-align: right" class="footer-block-class">
                                <span style="margin-right: 100px;cursor: pointer;" @click="onClickPrivacyPolicy">
                                    - {{$t('login.privacyPolicy')}} -
                                </span>
                        </div>
                    </div>

                    <div style="text-align: center">
                        {{$t('login.version', {value: appVersion})}}
                    </div>
                </div>
            </el-col>
        </el-row>
        <div class="login_loading" v-if="isShowLoginLoading">
            <div class="load-icon">
                <img src="../../assets/image/waiting.png" class="animate-img"/>
            </div>
        </div>
    </div>


</template>

<script>
    import {CustomerConfig} from '@/services/customer/CustomerConfig'
    import regExp from "@/assets/js/RegExp";
    import { version } from "../../../package.json"

    export default {
        name: "Login",
        beforeCreate () {
            console.log(this.$i18n.locale,  999)
        },
        data() {
            return {
                a: 999,
                loadingStatus: false,
                user: {
                    name: '',
                    password: '',
                    remember: false
                },
                rules: {
                    name: [
                        {
                            required: true,
                            message: this.$t('tips.login.pleaseInputYourEmailOrUserId'),
                            trigger: 'submit'
                        },
                        {
                            min: 6,
                            max: 64,
                            message: this.$t('globalText.mustContainBetween_X_To_Y_Characters', {min: 6, max: 64}),
                            trigger: 'submit'
                        }
                    ],
                    password: [
                        {required: true, message: this.$t('tips.resetPwd.pleaseInputThePassword'), trigger: 'submit'}
                    ]
                },
                isShowLoginLoading: false
            }
        },
        computed: {
            appVersion () {
                return version
            },
            year() {
                return new Date().getFullYear();
            }
        },
        methods: {
            getLogo (imageName) {
                return CustomerConfig.getLoginLogo(imageName)
            },
            isPrivacyPolicyShow () {
                return CustomerConfig.getLoginPrivacyPolicyShow(true)
            },
            isShowAndroid () {
                return CustomerConfig.getLoginAndroidShow(true)
            },
            isShowIOS () {
                return CustomerConfig.getLoginIOSShow(true)
            },
            getQrcodeAndroid (imageName) {
                return CustomerConfig.getLoginAndroidQRCode(imageName)
            },
            getQrcodeIOS (imageName) {
                return CustomerConfig.getLoginIOSQRCode(imageName)
            },
            getAppStoreIcon(){
               let language = this.$store.getters['i18n/localLanguage'];
               switch (language) {
                   case ('en-US'): return require("../../assets/image/appstore_en.png")
                   case ('zh-CN'): return require("../../assets/image/appstore_zh_cn.png")
                   case ('zh-TW'): return require("../../assets/image/appstore_zh_tw.png")
                   case ('ja-JP'): return require("../../assets/image/appstore_ja.png")
               }
            },
            getGooglePlayIcon(){
                let language = this.$store.getters['i18n/localLanguage'];
                switch (language) {
                    case ('en-US'): return require("../../assets/image/googleplay_en.png")
                    case ('zh-CN'): return require("../../assets/image/googleplay_zh_cn.png")
                    case ('zh-TW'): return require("../../assets/image/googleplay_zh_tw.png")
                    case ('ja-JP'): return require("../../assets/image/googleplay_ja.png")
                }
            },
            getWelcome (value) {
                const content = this.$t(value)
                return CustomerConfig.getLoginWelcome(content, this.$i18n.locale)
            },
            getCopyright (value) {
                const content = this.$t(value, {year: this.year})
                return CustomerConfig.getLoginCopyright(content, this.$i18n.locale)
            },
            onClickPrivacyPolicy() {
                let routeData = this.$router.resolve({name: "privacyPolicyDetail"});
                window.open(routeData.href, '_blank');
            },
            nameInputNoSpace() {
                this.clearValidate('name');
                this.user.name = regExp.inputNoSpace(this.user.name);
            },
            passwordInputNoSpace() {
                this.clearValidate('password');
                this.user.password = regExp.inputNoSpace(this.user.password);
            },
            clearValidate(prop) {
                this.$refs['user'].clearValidate(prop);
            },
            submitForm(user) {
                //login网络请求之前清除localStorage中的RequestHistory记录
                localStorage.removeItem('RequestHistory');
                this.loadingStatus = true;
                this.isShowLoginLoading = true;
                this.$refs[user].validate((valid) => {
                    if (valid) {
                        this.$serverApi.auth.login(this.user.name, this.user.password, () => {
                            this.$store.dispatch('updateCompanyInfo').then(() => {
                                this.$router.push("/liveTracking").catch();
                                this.loadingStatus = false;
                                this.isShowLoginLoading = false;
                            }).catch(() => {
                                this.loadingStatus = false;
                                this.isShowLoginLoading = false;
                            })
                        }, () => {
                            this.loadingStatus = false;
                            this.isShowLoginLoading = false;
                        });

                    } else {
                        this.loadingStatus = false;
                        this.isShowLoginLoading = false;
                        return false;
                    }
                });
            },
            forgetPassword() {
                this.$router.push({name: 'verify'}).catch();
            }
        }
    }
</script>

<style lang="stylus" scoped>
    @import "~@/assets/stylus/color.styl"
    $ry_main_color = $color_blue_first
    $ry_content_bg_color = $color_gray_third
    $ry_content_before_bg_color = $color_gray_first

    .login-main
        overflow-y auto
        height 100%
        min-width: 1366px;
        .login-top
            padding-top 20px
            background-color $ry_main_color
            height 240px
            text-align center
            .login-welcome
                font-size 30px
                color $color_white
                line-height 40px

    .login-contents
        background-color $ry_content_bg_color
        padding-top 15px
        padding-left 10px
        padding-right 10px
        height calc(100% - 240px)
        min-height 650px
        .login-form-box
            background-color $ry_content_before_bg_color
            width 100%
            height 100%
            .login-left-top-tag
                position absolute
                top 15px

            .login-box
                width 100%
                display flex
                justify-content space-evenly
                align-items flex-end
                min-height 480px

                .login-box-right .login-box-left
                    width 160px
                    text-align center
                    display inline-block
                    line-height 28px

                .login-message-box
                    width 450px
                    position absolute
                    top 50px
                    left 80px
                    color $color_black_third
                    font-size 14px
                    line-height 28px

                    .login-info
                        text-indent 28px

                    .login-title
                        margin-bottom 20px

                    .login-img
                        margin-top 15px

                .login-form
                    padding 0 20px 30px
                    background-color $color_white

                    .input, .tips
                        margin-bottom 0

                    .input > .error_tips
                        width 100%
                        padding-top 2px
                        padding-bottom 2px
                        min-height 20px
                        color red
                        font-size 14px
                        font-weight 400

                    .tips
                        width 100%
                        margin-bottom 15px

                        .right
                            text-align right
                            display inline-block
                            padding 5px
                            float right
                            font-size 14px
                            font-weight 400

                    .btn
                        padding-top 20px

                    .sign
                        width 100%
                        background-color $color_blue_second

                    .sign:hover
                        background-color $color_blue_second !important
                        opacity: 0.9

                    .sign:active
                        background-color $color_blue_second !important
                        opacity: 0.95

                    .login-forget-pwd
                        color $color_black_third
                        padding-top 10px
                        padding-bottom 40px

                        .right
                            text-align right
                            display inline-block
                            padding 5px
                            float right
                            font-size 12px
                            cursor pointer
                        .right:hover
                            color $color_blue_second
                            text-decoration underline

    .login-footer-box
        margin-top 120px
        height 50px
        line-height 25px
        color $color_black_third
        background-color $ry_content_before_bg_color

        .privacy-policy
            cursor pointer
            height 100%
            background-color #5daf34

        .footer-block-class
            width: 33.33%
            display: inline-block;

    >>> .el-form-item__error
        left 56px

    >>> .el-message-box__wrapper >>> .el-message-box__btns
        text-align center

    .login_loading
        position fixed
        width 100%
        height 100%
        top 0

    .load-icon
        position fixed
        width 200px
        height 200px
        top calc(50% - 100px)
        left calc(50% - 100px)
        border-radius 10px
        -webkit-user-select none;
        -moz-user-select none;
        -ms-user-select none;
        user-select none;

    .animate-img
        margin-left 55px
        margin-top 55px
        animation rotate 1s linear infinite

    @keyframes rotate
        0% {
            transform rotateZ(0deg)
        }
        100% {
            transform rotateZ(360deg)
        }

</style>
